import React, {Component} from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import {withStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import CloseIcon from "@material-ui/icons/Close";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import {DialogActions, FormControl} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {TITRE_FORMULAIRE_CONTACT, VALIDE_FORMULAIRE_CONTACT} from "../../text";
import TextField from "@material-ui/core/TextField";
import {ajouterUnWebsite} from "../../services/api";

import { loadReCaptcha } from 'react-recaptcha-v3'
import { ReCaptcha } from 'react-recaptcha-v3'
import * as ReactGA from "react-ga";

const styles = theme => ({
	appBar: {
		position: "relative"
	},
	flex: {
		flex: 1
	},
	dialogSize: {
		[theme.breakpoints.up("sm")]: {
			height: "69vh",
			width: "42vw",
			margin: '0 auto',
			top: "9vh"
		}
	},
	form: {
		width: '98%',
		marginTop: '15px',
		margin: "0 auto",
		"& > div": {
			margin: "0.4em"
		}
	},
	actionBar: {
		justifyContent: "center"
	}
});

export class IFormContact {
	nom = null;
	prenom = null;
	email = null;
	societe = null;
	telephone = null;
	projet = null;
	session = null;
}

const formatterTelephone = (string) => {
	return string.replace(/([^0-9+])/gi, "");
};

const formatterEmail = (string) => {
	return string.replace(/([^0-9+_\-a-z@.])/gi, "");
};

class FormContact extends Component {

	auMoinsUneInfoClient = false;

	close = () => {

		this.setState({
			formContact: new IFormContact(),
			formError: new IFormContact()
		});

		this.props.closeMe();
	};


	checkInput = (input) => {

		let formContactContent = [];
		let formContactError = [];

		if (this.state.formContact) {
			formContactContent = this.state.formContact;
			formContactError = this.state.formError;
		}

		let formError = false;
		formContactError[[input]] = false;

		if (formContactContent[[input]] === null || formContactContent[[input]] === "") {
			if(((input === "telephone" || input === "email") && !this.auMoinsUneInfoClient) || (input !== "telephone" && input !== "email")){
				formContactError[[input]] = true;
				formError = true;
			}
		} else if (input === "email") {
			formContactContent[[input]] = formatterEmail(formContactContent[[input]]);

			if (/.+@.+\.[A-Za-z]+$/.test(formContactContent[[input]]) !== true) {
				formContactError[[input]] = true;
				formError = true;
			} else{
				this.auMoinsUneInfoClient = true;
				formContactError[["telephone"]] = false;
			}
		} else if (input === "telephone") {

			formContactContent[[input]] = formatterTelephone(formContactContent[[input]]);

			if (/[0-9+]{10,12}$/.test(formContactContent[[input]]) !== true) {
				formContactError[[input]] = true;
				formError = true;
			} else{
				this.auMoinsUneInfoClient = true;
				formContactError[["email"]] = false;
			}
		}

		this.setState({
			formContact: formContactContent,
			formError: formContactError,
		});

		return formError;
	};

	envoyerLeFormulaire = () => {

		if(this.state.isCaptchaValid) {
			const champsRequis = ['nom', 'email', 'telephone', 'societe'];

			let formError = false;
			this.auMoinsUneInfoClient = false;

			champsRequis.map(input => {

				formError = this.checkInput(input);

				return true;
			});

			if (!formError) {

				ReactGA.event({
					category: 'Eligibilite',
					action: 'Envoyer le formulaire',
				});

                let formContactContent = this.state.formContact;

                formContactContent['session'] = this.props.sessionApi;

				ajouterUnWebsite(formContactContent);

				this.props.closeMe();
			}
		}
	};

	setValue = (inputName) => (event) => {

		let formContactContent = [];

		if (this.state.formContact) {
			formContactContent = this.state.formContact;
		}

		formContactContent[[inputName]] = event.target.value;

		this.setState({
			formContact: formContactContent,
		});

		this.checkInput(inputName);
	};

	constructor(props) {

		super(props);
		this.state = {
			formContact: new IFormContact(),
			formError: new IFormContact()
		}
	}

	componentDidMount() {
		loadReCaptcha('6Ldgp1gUAAAAAE5fpyKLUUyY7CAt8gv7cMqLU6zT');
	}

	onCaptchaVerify = (response) => {
		this.setState({
			isCaptchaValid: true
		})
	}

	render() {
		const {value, classes, closeMe, ...other} = this.props;

		return (
			<Dialog
				className={classes.dialogSize}
				fullScreen
				disableBackdropClick
				disableEscapeKeyDown
				{...other}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<Typography
							color="inherit"
							variant="h6"
							className={classes.flex}
						>
							{TITRE_FORMULAIRE_CONTACT}
						</Typography>
						<IconButton color="inherit" onClick={this.close}>
							<CloseIcon/>
						</IconButton>
					</Toolbar>
				</AppBar>

				<DialogContent className={classes.flex}>
					<FormControl className={classes.form}>
						<TextField
							error={this.state.formError.societe}
							value={this.state.formContact.societe}
							id="societe-input"
							label="Société"
							variant="outlined"
							defaultValue=""
							onChange={this.setValue("societe")}
						/>

						<TextField
							error={this.state.formError.nom}
							value={this.state.formContact.nom}
							id="Nom-input"
							label="Nom"
							defaultValue=""
							variant="outlined"
							onChange={this.setValue("nom")}
						/>

						<TextField
							error={this.state.formError.prenom}
							value={this.state.formContact.prenom}
							id="Prenom-input"
							label="Prénom"
							variant="outlined"
							defaultValue=""
							onChange={this.setValue("prenom")}
						/>

						<TextField
							error={this.state.formError.telephone}
							value={this.state.formContact.telephone}
							id="telephone-input"
							label="Téléphone"
							variant="outlined"
							defaultValue=""
							onChange={this.setValue("telephone")}
						/>
						<TextField
							error={this.state.formError.email}
							value={this.state.formContact.email}
							id="email-input"
							label="Adresse E-Mail"
							variant="outlined"
							defaultValue=""
							type="email"
							autoComplete="email"
							onChange={this.setValue("email")}
						/>

						<TextField
							error={this.state.formError.projet}
							id="demande-input"
							label="Votre projet"
							multiline
							rows="4"
							variant="outlined"
							defaultValue=""
							onChange={this.setValue("projet")}
						/>
					</FormControl>


					<ReCaptcha
						sitekey="6Ldgp1gUAAAAAE5fpyKLUUyY7CAt8gv7cMqLU6zT"
						verifyCallback={this.onCaptchaVerify}
						render="explicit"
					/>
				</DialogContent>
				<DialogActions className={classes.actionBar}>
					<Button
						variant="contained"
						color="primary"
						onClick={this.envoyerLeFormulaire}
					>
						{VALIDE_FORMULAIRE_CONTACT}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

export default withStyles(styles)(FormContact);

